// src/utils/axiosInstance.ts

import axios from 'axios';
import { toast } from "react-toastify"; // import toast

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001", // Set your base URL here
});

// Request Interceptor to add the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Attach token to Authorization header
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response Interceptor to handle errors globally
axiosInstance.interceptors.response.use(
  (response) => response, // Simply return the response if successful
  (error) => {
    if (axios.isAxiosError(error)) { // Correct usage of isAxiosError
      if (error.response) {
        // La sesión es persistente en el dispositivo: NO cerramos sesión ni
        // redirigimos al login automáticamente ante un 401 (token ausente/expirado).
        if (error.response.status === 403) {
          // Forbidden - insufficient permissions
          toast.error('No tienes permisos para realizar esta acción.');
        }
        // Handle other status codes as needed
      } else if (error.request) {
        // The request was made but no response was received
        toast.error('No se recibió respuesta del servidor. Inténtalo de nuevo más tarde.');
      } else {
        // Something happened in setting up the request
        toast.error('Error al configurar la solicitud.');
      }
    } else {
      // Non-Axios error
      toast.error('Ocurrió un error inesperado.');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
